<!--
 * @Author: xiaokun
 * @Date: 2020-04-10 16:19:37
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-10 17:51:58
 * @Description: 考试表格 操作组件
 -->
<template>
  <div class="list-table-action">
    <mk-button
      type="text"
      class="list-table-action__apply"
      @click="handleOnEditClick"
    >
      编辑
    </mk-button>
    <mk-popover
      v-model="showPopover"
      placement="top"
      trigger="click"
      popper-class="qrcode-delete-confirm"
      reference
    >
      <div>
        <div class="mention-text">
          <mk-iconfont icon-class="guanbihuojingshihuocuowu" />确认删除该考试吗？
        </div>
        <div class="button-delete-button">
          <mk-button-biz
            width="50px"
            height="24px"
            @click="handleOnEnterDeleteClick"
          >
            确定
          </mk-button-biz>
          <mk-button-biz
            width="50px"
            height="24px"
            type="primary"
            @click="showPopover = false"
          >
            取消
          </mk-button-biz>
        </div>
      </div>
      <mk-button
        slot="reference"
        type="text"
        class="list-table-action__remove"
      >
        删除
      </mk-button>
    </mk-popover>
  </div>
</template>

<script>
export default {
  name: 'ListTableAction',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      showPopover: false
    }
  },
  mounted () {
  },
  methods: {
    // 删除
    handleOnEnterDeleteClick () {
      this.showPopover = true
      this.$emit('on-delete-click', this.scope.row)
    },
    // 编辑
    handleOnEditClick () {
      this.$emit('on-edit-click', this.scope.row)
    }
  }
}
</script>

<style lang="scss" scoped>
// 删除浮层
.qrcode-delete-confirm {
  .mention-text {
    font-size: 14px;
    color: #595959;

    .icon-mk-guanbihuojingshihuocuowu {
      font-size: 14px;
      color: #f5222d;
      margin-right: 8px;
    }
  }

  .button-delete-button {
    margin-top: 12px;
    text-align: right;
  }
}

.list-table-action__remove,
.list-table-action__apply {
  font-size: 13px;
}

.list-table-action__remove {
  margin-left: 14px;
}
</style>
